import { createAction, props } from '@ngrx/store';

import { UserInformation } from './authentication.models';

export const changed = createAction(
  '[Authentication] Changed',
  props<{
    authenticated?: boolean;
    employee?: boolean;
    exclude_analytics?: boolean;
    sub?: string;
    userInfo?: UserInformation;
  }>()
);

export const unchanged = createAction('[Authentication] Unchanged');
